import {
  BrandfolderHexColors,
  FontIcon,
  FontIconPositions,
  FontIcons,
} from '@brandfolder/react';
import { t, Trans } from '@lingui/macro';
import React, { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';

import styled from 'styled-components';

import { SecondaryWhiteButton } from '../common/SecondaryWhiteButton';

const FaceCardWrapper = styled.div`
  box-shadow: 1px 2px 6px 0 rgba(0, 0, 0, 0.09);
`;
const ImageWrapper = styled.div`
  cursor: pointer;
  display: flex;
  position: relative;
`;
const ActionsWrapper = styled.div`
  align-items: center;
  background-color: rgba(0, 1, 1, 0.7);
  display: flex;
  height: 100%;
  opacity: 0;
  justify-content: center;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  &:hover,
  &:focus,
  &:focus-within {
    opacity: 1;
  }
`;
const CardLabelWrapper = styled.div`
  align-items: center;
  display: flex;
  height: 52px;
  padding: 0 16px;
`;
const CardImage = styled.img`
  height: 200px;
  object-fit: cover;
  width: 100%;
`;
const TagPersonLinkIcon = styled(FontIcon)`
  vertical-align: middle;
`;
const TagPersonLinkText = styled.span`
  color: ${BrandfolderHexColors.PurplePopsicle};
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  vertical-align: middle;
  &:hover {
    color: #314CA9;
  }
`;
const CardLabel = styled.div`
  color: #353a4a;
  font-size: 14px;
  font-weight: 450;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

interface FaceCardProps {
  id: string;
  imageUrl: string;
  label?: string;
}

export const FaceCard: FunctionComponent<FaceCardProps> = ({
  id,
  imageUrl,
  label = undefined,
}) => (
  <FaceCardWrapper>
    <ImageWrapper>
      <ActionsWrapper>
        <SecondaryWhiteButton
          buttonText={!label ? t`Tag person` : t`View person`}
          linkTo={id}
        />
      </ActionsWrapper>
      <CardImage alt="person" src={imageUrl} />
    </ImageWrapper>
    <CardLabelWrapper>
      {!label ? (
        <Link to={id}>
          <TagPersonLinkIcon
            icon={FontIcons.Tag}
            iconSize={14}
            position={FontIconPositions.Left}
          />
          <TagPersonLinkText>
            <Trans>Tag person</Trans>
          </TagPersonLinkText>
        </Link>
      ) : (<CardLabel>{label}</CardLabel>)}
    </CardLabelWrapper>
  </FaceCardWrapper>
);
